import React from 'react'
import { Index } from 'react-instantsearch-dom'
import CategoriesList from './CategoriesListConnected'
import { getCourseIndex } from '../../getIndexNames'

const courseIndex = getCourseIndex()
const Categories = () => (
  <Index indexName={courseIndex}>
    <CategoriesList attribute='category' limit={20} />
  </Index>
)

export default Categories
